<template>
  <div class="about-us-wrapper">
    <div class="journal-top clearfix">
      <div class="jonaral-left">
        <!-- <search></search> -->
      </div>
    </div>
    <div class="con-center">
      纪检监察监督举报电话：022-27539055
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      
    };
  },
  methods:{
    ...mapActions(["firstTitle"]),
  },
  mounted(){
    this.firstTitle('纪检监察监督举报')
  }
};
</script>

<style lang='less' scoped>
@import "../../common/minix.less";
.about-us-wrapper {
  width: 100%;
  margin: 0 auto;
}
.jonaral-left {
  width: 310 / @rem;
  margin-right: 30/ @rem;
  float: left;
}
.active {
  color: #194eb0 !important;
}
.padd {
  padding: 0 8/ @rem;
}
.con-center {
  padding: 40/ @rem 0;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  font-size: 28/ @rem;
}
</style>




// WEBPACK FOOTER //
// src/components/conUs/supervise.vue